module.exports = __webpack_public_path__ + "img/slide_bg_02.e1b33de8.png";